import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { STORAGE_KEYS } from '../../constants/storage.constants';
import { AUTH_ROUTES } from '../../constants/auth.constants';

interface StoredRedirectUrl {
  url: string;
  timestamp: number;
}

@Injectable({ providedIn: 'root' })
export class RedirectUrlService {
  private localStorageService = inject(LocalStorageService);

  private readonly TIMEOUT_MS = 3 * 60 * 1000;

  setRedirectUrl(url: string): void {
    if (!this.isValidInternalPath(url)) {
      return;
    }

    if (this.isAuthRoute(url)) {
      return;
    }

    const data: StoredRedirectUrl = {
      url,
      timestamp: Date.now()
    };

    this.localStorageService.store(STORAGE_KEYS.REDIRECT_URL, data);
  }

  getValidRedirectUrl(): string | null {
    const data = this.localStorageService.retrieve(STORAGE_KEYS.REDIRECT_URL) as StoredRedirectUrl | null;

    if (!data) {
      return null;
    }

    const elapsed = Date.now() - data.timestamp;

    if (elapsed > this.TIMEOUT_MS) {
      this.clearRedirectUrl();
      return null;
    }

    if (!this.isValidInternalPath(data.url)) {
      this.clearRedirectUrl();
      return null;
    }

    return data.url;
  }

  clearRedirectUrl(): void {
    this.localStorageService.clear(STORAGE_KEYS.REDIRECT_URL);
  }

  private isValidInternalPath(url: string): boolean {
    if (typeof url !== 'string' || url.length === 0) return false;
    if (!url.startsWith('/')) return false;
    if (url.startsWith('//')) return false;
    return true;
  }

  private isAuthRoute(url: string): boolean {
    return AUTH_ROUTES.some(route => url.startsWith(route));
  }
}
